<main class="container" role="main">
  <h1>Privacy Policy</h1>

  <p>
    This Privacy Policy describes how <strong>MoreTech</strong> collects,
    uses, discloses, and protects personal information when you use our
    mobile application and related services. MoreTech is a B2B e-commerce
    mobile application for technology resellers and providers.
  </p>

  <h2>1. Scope</h2>
  <p>
    This policy applies to personal data collected through the MoreTech
    mobile application (iOS & Android), and any related services (APIs,
    web portals accessed by providers/super-admins) that we operate.
  </p>

  <h2>2. Information we collect</h2>
  <p>We collect the following types of information to provide, operate, and improve our services:</p>

  <h3>2.1 Account & Business Information</h3>
  <ul>
    <li>Full name, business/store name, business registration, email, phone.</li>
    <li>Profile info, delivery addresses, bank/cheque details if using cheque payments.</li>
  </ul>

  <h3>2.2 Order & Payment Information</h3>
  <ul>
    <li>Order details (products, quantities, prices, order history).</li>
    <li>Payment method details & transaction metadata (multiple local payment methods supported).</li>
    <li>No full card numbers stored; handled by third-party gateways.</li>
  </ul>

  <h3>2.3 Device & Usage Data</h3>
  <ul>
    <li>Device identifiers, OS/app version, IP, logs, crash reports, analytics.</li>
  </ul>

  <h3>2.4 Location Data</h3>
  <ul>
    <li>Delivery addresses & geolocation (Google Maps) to fulfil orders accurately.</li>
  </ul>

  <h2>3. How we use personal data</h2>
  <ul>
    <li>Process orders, verify payments, manage returns/refunds.</li>
    <li>Customer support and service requests.</li>
    <li>Maintain accounts, authentication, and security.</li>
    <li>Improve and personalize the app, analytics, fraud detection.</li>
    <li>Send notices, transactional emails, and updates.</li>
  </ul>

  <h2>4. Sharing & disclosure</h2>
  <p>We may share personal information with:</p>
  <ul>
    <li>Service providers & payment processors.</li>
    <li>Logistics & delivery partners.</li>
    <li>Providers and salespersons for order fulfilment.</li>
    <li>When required by law.</li>
  </ul>

  <h2>5. Data retention</h2>
  <p>We retain personal information as long as needed for services, legal compliance, and business purposes.</p>

  <h2>6. Security</h2>
  <p>We implement reasonable safeguards: JWT authentication, encrypted storage, TLS, regular security reviews.</p>

  <h2>7. Your rights and choices</h2>
  <p>Depending on your location, you may access, correct, export, or delete your data. Contact us to exercise these rights.</p>

  <h2>8. Cookies & similar technologies</h2>
  <p>Our app and web interfaces may use cookies and local storage. Preferences can be managed via device settings.</p>

  <h2>9. Minors</h2>
  <p>Our services are for businesses/resellers. We do not knowingly collect data from children under 16.</p>

  <h2>10. International transfers</h2>
  <p>Data may be processed/stored outside your country. We adopt standard safeguards.</p>

  <h2>11. Third-party links & services</h2>
  <p>Our app may link/embed third-party services (payment gateways, Google Maps). Review their policies before sharing personal info.</p>

  <footer>
    &copy; {{ currentYear }} MoreTech. All rights reserved.
  </footer>
</main>
